var _mask, _path, _path2, _mask2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySendddd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.53c0 .54.15.62.49.74l.51.18v-1.7h-.3c-.38 0-.7.35-.7.78"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13181b",
    d: "M10.25 10.53c0 .54.15.62.49.74l.51.18v-1.7h-.3c-.38 0-.7.35-.7.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "m10.74 11.27-.333.943zm.51.18-.333.943 1.333.47V11.45zm0-1.7h1v-1h-1zm-2 .78c0 .317.033.764.33 1.143.286.367.696.494.827.54l.666-1.886-.079-.029-.005-.002a.6.6 0 0 1 .167.146c.07.09.092.169.098.193.003.015-.004-.01-.004-.105zm1.157 1.683.51.18.666-1.886-.51-.18zm1.843-.763v-1.7h-2v1.7zm-1-2.7h-.3v2h.3zm-.3 0c-1.026 0-1.7.897-1.7 1.78h2a.18.18 0 0 1-.05.119.34.34 0 0 1-.25.101z",
    mask: "url(#a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.25h.3c.39 0 .7-.35.7-.78 0-.54-.15-.62-.49-.74l-.51-.18z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#13181b",
    d: "M12.75 15.25h.3c.39 0 .7-.35.7-.78 0-.54-.15-.62-.49-.74l-.51-.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M12.75 15.25h-1v1h1zm.51-1.52.333-.943zm-.51-.18.333-.943-1.333-.47v1.413zm0 2.7h.3v-2h-.3zm.3 0c1.045 0 1.7-.906 1.7-1.78h-2c0-.025.009-.069.05-.115a.34.34 0 0 1 .25-.105zm1.7-1.78c0-.317-.033-.764-.33-1.143-.286-.367-.696-.494-.827-.54l-.666 1.886.079.029.005.002a.6.6 0 0 1-.167-.146.5.5 0 0 1-.098-.193c-.003-.015.004.009.004.105zm-1.157-1.683-.51-.18-.666 1.886.51.18zm-1.843.763v1.7h2v-1.7z",
    mask: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "m19.58 5.98-2.05 2.05c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2.05-2.05C16.76 3.42 14.49 2.5 12 2.5c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10c0-2.49-.92-4.76-2.42-6.52m-5.83 6.34c.64.23 1.5.69 1.5 2.16 0 1.25-.99 2.28-2.2 2.28h-.3v.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.25h-.08c-1.33 0-2.42-1.12-2.42-2.5 0-.42.34-.76.75-.76s.75.34.75.75c0 .55.41 1 .92 1h.08v-2.22l-1-.35c-.64-.23-1.5-.69-1.5-2.16 0-1.25.99-2.28 2.2-2.28h.3V8c0-.41.34-.75.75-.75s.75.34.75.75v.25h.08c1.33 0 2.42 1.12 2.42 2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.55-.41-1-.92-1h-.08v2.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#13181b",
    stroke: "#0b75c2",
    d: "m20.896 3.956-1.3 1.3a11 11 0 0 0-.352-.353l1.3-1.3.853-.853H18a.256.256 0 0 1-.25-.25c0-.134.116-.25.25-.25h4a.3.3 0 0 1 .1.018.3.3 0 0 1 .13.137c.017.046.02.071.02.095v4c0 .134-.116.25-.25.25a.256.256 0 0 1-.25-.25V3.103z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySendddd);
export default __webpack_public_path__ + "static/media/money-sendddd.8d23e404fbac940cb9ae89a6977f5f06.svg";
export { ForwardRef as ReactComponent };